import {WebConferenceService} from "@share/web-conferences/data/WebConferenceService";
import {Store} from "vuex";
import {joinedUserIdsGetter} from "@share/web-conferences/store/getters";
import {stateKey} from "@share/web-conferences/helpers/StateKey";

const timeoutDuration = 15000;
const timeoutConfig = {
    timerId: 0
}

export const clearTimeoutForCurrentPresentation = (): void => {
    clearTimeout(timeoutConfig.timerId);
}

export const runTimeoutForCurrentPresentation = (
    webConferenceService: WebConferenceService | null,
    store: Store<any>
) => {
    clearTimeoutForCurrentPresentation();
    //@todo check if it will make pdf empty if the new user already sharing
    console.log('running timer');
    // wss://livekit.test.appercode.com
    // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2aWRlbyI6eyJjYW5QdWJsaXNoRGF0YSI6dHJ1ZSwiY2FuU3Vic2NyaWJlIjp0cnVlLCJyb29tQWRtaW4iOnRydWUsInJvb21DcmVhdGUiOnRydWUsInJvb21Kb2luIjp0cnVlLCJjYW5QdWJsaXNoIjp0cnVlLCJyb29tIjoiMzllZjliODQtZjIzMy00MWFmLWFiOTQtM2YwN2M0NWQ5MTEyQCJ9LCJzdWIiOiI4IiwianRpIjoiOCIsIm5iZiI6MTY0ODE4NzA4NSwiZXhwIjoxNjQ4MjAxNDg1LCJpYXQiOjE2NDgxODcwODUsImlzcyI6IkFQSTlrRjNnQkNoaXRxViJ9.yK_05FgqpixD85NUlDUvPRPyo1uGJdzU1asfMPah9RM
    if (webConferenceService?.webConferenceData?.isSharing()) {
        timeoutConfig.timerId = window.setTimeout(() => {
          if (webConferenceService?.webConferenceData?.isSharing()) {
              const key = stateKey(webConferenceService?.schemaId, webConferenceService?.objectId);
              const joinedUserIds = store.getters[joinedUserIdsGetter](key);
              if (joinedUserIds.indexOf(webConferenceService?.webConferenceData?.currentPresentation?.userId) < 0) {
                  webConferenceService?.setCurrentPresentation(null, false);
              }
          }
      }, timeoutDuration)
    }
}
